import { render, staticRenderFns } from "./TransitVisa.vue?vue&type=template&id=0de70e96&"
import script from "./TransitVisa.vue?vue&type=script&lang=js&"
export * from "./TransitVisa.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports